import { render } from "./UiLink.vue?vue&type=template&id=6d2c689e&scoped=true"
import script from "./UiLink.vue?vue&type=script&lang=js"
export * from "./UiLink.vue?vue&type=script&lang=js"

import "./UiLink.vue?vue&type=style&index=0&id=6d2c689e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2c689e"]])

export default __exports__